import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  /* eslint-disable */
  apiServer: apiServer,
  /* eslint-enable */
  user: null,
  token: null,
  notify: { title: '', desc: '', type: 'warn', timeout: 3000 },
  appLoading: false
}

const mutations = {
  SET_USER (state, user) {
    state.user = user
    window.localStorage.setItem('hyy_www_user', JSON.stringify(user))
  },
  LOG_OUT (state) {
    state.user = null
    state.token = null
    state.menus = []
    state.access = []
    window.localStorage.removeItem('hyy_www_user')
    window.localStorage.removeItem('hyy_www_token')
  },
  updateAppLoading (state, payload) {
    state.appLoading = payload
  }
}

const actions = {
  LOG_OUT ({commit}) {
    commit('LOG_OUT')
  },
  SET_USER (state, user) {
    state.commit('SET_USER', user)
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
